/** Mes e abas da carteira (so calendario e texto; nenhum valor monetario). */

export const ABAS_CARTEIRA = ['pedidos', 'resumo', 'calendario'] as const;
export type AbaCarteira = (typeof ABAS_CARTEIRA)[number];

const RE_MES = /^\d{4}-(0[1-9]|1[0-2])$/;

/** Busca da URL: `mes` (AAAA-MM) e `aba`. Valor invalido e descartado (volta ao padrao). */
export function lerBuscaCarteira(bruto: Record<string, unknown>): { mes?: string; aba?: AbaCarteira } {
  const mes = typeof bruto.mes === 'string' && RE_MES.test(bruto.mes) ? bruto.mes : undefined;
  const aba = ABAS_CARTEIRA.find((a) => a === bruto.aba);
  return { ...(mes ? { mes } : {}), ...(aba ? { aba } : {}) };
}

/** Mes corrente no fuso local, AAAA-MM. */
export function mesAtual(): string {
  const agora = new Date();
  return `${agora.getFullYear()}-${String(agora.getMonth() + 1).padStart(2, '0')}`;
}

/** Soma `delta` meses ao AAAA-MM (so calendario). */
export function deslocarMes(mes: string, delta: number): string {
  const [ano, m] = mes.split('-').map(Number) as [number, number];
  const total = ano * 12 + (m - 1) + delta;
  const novoAno = Math.floor(total / 12);
  const novoMes = (total % 12) + 1;
  return `${novoAno}-${String(novoMes).padStart(2, '0')}`;
}

/** "2026-10" vira "10/2026" (reordena os campos, sem nome de mes). */
export function rotuloMes(mes: string): string {
  const [ano, m] = mes.split('-');
  return ano && m ? `${m}/${ano}` : mes;
}
